<template>
  <v-dialog v-if="checkIfCanSimular()" v-model="dialog" width="850">
    <template style="background-color: red; width: 100%" v-slot:activator="{ on, attrs }">
      <v-spacer></v-spacer>
      <v-btn color="green" class="mt-2 white--text" dark @click="simulacao()" v-bind="attrs" v-on="on">
        <v-icon left dark>payments</v-icon>
        Simular Quitação
      </v-btn>
    </template>

    <v-card v-if="!save">
      <v-card-title class="text-subtitle white--text primary" dark>
        Simulação
      </v-card-title>
      <v-card-text>
        <section>
          <v-row v-if="!generateSimulacion && DataSimulacao" class="ma-1">
            <v-col class="pa-0" cols="12" md="12">
              <p class="text-subtitle-1 mt-3 ma-0 pa-0 mb-2" style="width: 100%">
                <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Contribuinte:</strong>
                {{ DataSimulacao.contribuinte.nomeRazaoSocial || "" }} /
                {{ DataSimulacao.contribuinte.cpfCnpj | cnpjCpfFilter }}
              </p>
            </v-col>
            <v-col class="pa-0" cols="12" md="6">
              <p class="text-decoration text-subtitle-1 ma-0 pa-0" style="width: 100%">
                <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Receita:</strong>
                {{ DataSimulacao.sefazReceita.descricao || "" }}
              </p>
            </v-col>

            <v-col class="pa-0" cols="12" md="6">
              <p class="text-subtitle-1 text-start ma-0 pa-0 text-justify" style="width: 100%">
                <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Produto:</strong>
                {{ DataSimulacao.sefazProduto.descricao || "" }}
              </p>
            </v-col>

            <v-col class="pa-0" cols="12" md="6">
              <p class="text-subtitle-1 ma-0 pa-0 text-start" style="width: 100%">
                <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Competência:</strong>
                {{ formatDate(DataSimulacao.competencia, "MM/YYYY") }}
              </p>
            </v-col>

            <v-col class="pa-0" cols="12" md="6">
              <p class="text-decoration text-subtitle-1 ma-0 pa-0" style="width: 100%">
                <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Data Cadastro:</strong>
                {{ formatDate(DataSimulacao.dataCadastro, "DD/MM/YYYY") }}
              </p>
            </v-col>
            <v-col class="pa-0" cols="12" md="6">
              <p class="text-subtitle-1 font-weight-medium ma-0 pa-0 text-start" style="width: 100%">
                <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Data Vencimento:</strong>
                {{ formatDate(DataSimulacao.dataVencimento, "DD/MM/YYYY") }}
              </p>
            </v-col>
            <!-- <v-col class="pa-0 pt-1" cols="12" md="12">
              <p
                class="text-decoration text-subtitle-1 ma-0 pa-0"
                style="width: 100%"
              >
                <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0"
                  >Juros:</strong
                >
                {{ DataSimulacao.valorJuros | monetaryFilter }}
              </p>
            </v-col> -->
            <v-col class="pa-0 mt-2" cols="12" md="12">
              <p class="text-subtitle-1 ma-0 pa-0" style="width: 100%">
                <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Saldo devedor:</strong>
                R$ {{ calcValortotal() | monetaryFilter }}
              </p>
            </v-col>
            <v-col class="pa-0 pb-2" cols="12" md="6">
              <p class="text-subtitle-1 ma-0 pa-0" style="width: 100%">
                <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Desconto:</strong>
                R$
                {{
                  (calcValortotal() - DataSimulacao.valorTotal) | monetaryFilter
                }}
              </p>
            </v-col>
            <v-col class="pa-0 mt-2" cols="12" md="12">
              <p class="text-decoration text-subtitle-1 ma-0 pa-0" style="width: 100%">
                <strong class="text-subtitle-1 font-weight-medium ma-0 pa-0">Observação:</strong>
                {{ DataSimulacao.informacaoComplementar || "" }}
              </p>
            </v-col>
            <v-divider class="mt-3 mb-3"></v-divider>
            <v-col class="mt-3" cols="12" md="12" style="border: 0.2px solid gray">
              <p class="ma-0 text-subtitle-1 font-weight-bold text-end" style="width: 100%">
                Valor a pagar: R$
                {{ DataSimulacao.valorTotal | monetaryFilter }}
              </p>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-flex>
              <v-container fill-height style="height: 350px">
                <v-row align="center" justify="center" class="text-center">
                  <v-col cols="12" class="d-flex align-center justify-center">
                    <section class="d-flex flex-column align-center justify-center" style="
                        background-color: #f5f5f5;
                        width: 180px;
                        height: 180px;
                        border-radius: 10px;
                      ">
                      <v-progress-circular indeterminate color="primary" class="mb-3"></v-progress-circular>
                      <strong class="mt-5">Gerando Simulação</strong>
                    </section>
                  </v-col>
                </v-row>
              </v-container>
            </v-flex>
          </v-row>
        </section>
      </v-card-text>

      <v-card-actions>
        <v-btn color="primary" text @click="dialog = false"> Cancelar </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="save = true"> Efetivar </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-text class="d-flex flex-column text-h6 text-center">
        <span>
          <v-icon class="mt-10 mb-2" x-large color="#FE8D5E">warning</v-icon>
        </span>
        <span class="text-subtitle-1 font-weight-medium mb-3">Tem certeza que deseja efetivar ?</span>
        <span class="text-subtitle-2 font-weight-regular">Ao confirmar, você estará efetivando a quitação antecipada da
          negociação. Essa ação não poderá ser desfeita.</span>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" text @click="save = false"> Não </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="loading" text @click="salvarSimulacao()">
          Sim
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import newNegociationService from "@/services/financeiro/new-negociation.service";
import moment from "moment";
import {
  dateFormat,
  monetaryFormat,
  revenueStatusFormat,
  competenciaFormat,
  cnpjCpfFormat,
} from "@/util/filters";
import GlobalStore from "@/store/modules/global";

export default {
  name: "SimularQuitacaoDialog",
  props: {
    idReceita: { type: Number },
    parcelas: { type: Array },
    cpfCnpj: { type: String },
  },
  data() {
    return {
      dialog: false,
      headers: [
        { text: "Competência", value: "competencia" },
        { text: "Data Criação", value: "dataCadastro" },
        { text: "Data vencimento", value: "dataVencimento" },
        { text: "Valor", value: "valorTotal" },
        { text: "Status", value: "receitaStatus" },
        { text: "Observaçao", value: "observacao" },
        // { text: "Parcela", value: "numeroParcelas" },
      ],
      DataSimulacao: null,
      save: false,
      loading: false,
      generateSimulacion: false,
    };
  },
  filters: {
    monetaryFilter: monetaryFormat,
    cnpjCpfFilter: cnpjCpfFormat,
  },
  methods: {
    simulacao() {
      this.generateSimulacion = true;
      newNegociationService
        .simularQuitacao(this.cpfCnpj, this.idReceita)
        .subscribe(
          (res) => {
            this.DataSimulacao = res;
            this.generateSimulacion = false;
          },
          (error) => {
            this.generateSimulacion = false;
          }
        );
    },
    salvarSimulacao() {
      this.loading = true;
      newNegociationService
        .salvarQuitacao(this.cpfCnpj, this.idReceita)
        .subscribe(
          (res) => {
            GlobalStore.setSnackBar({
              show: true,
              message: "Requisição realizada com sucesso!",
              type: "success",
            });
            this.dialog = false;
            this.save = false;
            this.$emit("updateReceita", { id: this.idReceita });
            this.loading = false;
          },
          (error) => {
            GlobalStore.setSnackBar({
              show: true,
              message: "Não foi possível realizar a requisição.",
              type: "error",
            });
            this.loading = false;
          }
        );
    },
    formatDate(date, format) {
      return moment(date).format(format);
    },
    calcValortotal() {
      const initialValue = 0;

      const valorPrincipal = this.parcelas
        .map((p) => {
          if (p.receitaStatus == "EM_ABERTO") {
            return p.valorTotal;
          } else {
            return 0;
          }
        })
        .reduce(
          (accumulator, currentValue) => accumulator + currentValue,
          initialValue
        )
        .toFixed(2);

      return valorPrincipal;
    },
    checkIfCanSimular() {
      const can = this.parcelas.some(p => p.receitaStatus == "EM_ABERTO")
      return can
    }
  },
  mounted() { },
};
</script>
<style>
.text-decoration {}
</style>
